export enum AuthWorkFlow {
  None = 'None',
  ChangePassword = 'ChangePassword'
}

export enum SendActivationCodeMode {
  unknown = 'unknown',
  change_password = 'change_password',
  identity_validation = 'identity_validation'
}

export enum VerificationMode {
    email = 'email',
    sms = 'sms'
}

// Mirrors the server's SmartLaunchType names as published on /api/auth/status launchType.
export enum SmartLaunchType {
  External = 'External',
  Embedded = 'Embedded'
}